var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1,.st2,.st3,.st4,.st5{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st1{clip-path:url(#SVGID_00000029732435915471078010000011347886611171302025_)}.st2{clip-path:url(#SVGID_00000136397382359018366340000007797672349563715201_)}.st3{clip-path:url(#SVGID_00000083056756840610043250000009440305078926562955_)}.st4{clip-path:url(#SVGID_00000064343560181947714790000008246044191635859113_)}.st5{clip-path:url(#SVGID_00000141413216716532495780000000567691794417519508_)}.st6,.st7{clip-path:url(#SVGID_00000047778757728154482350000015642321786753637555_)}.st6{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st7{fill:#16171c}.st8,.st9{clip-path:url(#SVGID_00000003105829293607305290000006676454204334464680_)}.st8{fill:none;stroke:#fff;stroke-width:6;stroke-linecap:round}.st9{fill:#fff}.st10{clip-path:url(#SVGID_00000056424564807753478460000002752189490733125559_);fill:none;stroke:#fff;stroke-linecap:round}.st10,.st12,.st13{stroke-width:6}.st12{clip-path:url(#SVGID_00000123418803187090036560000008118484090373050045_);fill:none;stroke:#fff;stroke-linecap:round}.st13{clip-path:url(#SVGID_00000019661780453346352900000017785114900104798603_)}.st13,.st14,.st15{fill:none;stroke:#fff;stroke-linecap:round}.st14{stroke-width:5;stroke-miterlimit:10}.st15{clip-path:url(#SVGID_00000176740692581447603420000001165954580788323720_);stroke-width:6}.st16{fill:#fff}.st17{fill:none;stroke:#fff;stroke-miterlimit:10}.st18,.st19,.st20{fill:none;stroke:#fff;stroke-linecap:round}.st18{clip-path:url(#SVGID_00000105428367635636358630000005000142176485418122_);stroke-width:6}.st19{stroke-width:3}.st20{stroke-width:4;stroke-miterlimit:10}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000158005397880621989220000010992260313022704044_",
    d: "M7.7 7.3h85.7V93H7.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102545648738226748100000012335315895387185796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158005397880621989220000010992260313022704044_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000102545648738226748100000012335315895387185796_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M18.2 34c-8.9 8.9-8.9 23.4 0 32.3l16.2 16.2c8.9 8.9 23.4 8.9 32.3 0l16.2-16.2c8.9-8.9 8.9-23.4 0-32.3L66.7 17.8c-8.9-8.9-23.4-8.9-32.3 0L18.2 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M50.6 34.8v31"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreV1);
export default __webpack_public_path__ + "static/media/exploreV1.0e9f0de19b202a696badc70191613cac.svg";
export { ForwardRef as ReactComponent };